module.exports = __webpack_public_path__ + "img/eddy-2024.349316cd.jpg";